import { ProgramAndCoursesInfo } from "../../../../types/gqlTypes/graphql"
import { FiltersState } from "../../states"
import { UserGoalsData } from "../../types"

export type ColumnFormatterContextType = {
  goals?: UserGoalsData[]
  programsAndCourses?: ProgramAndCoursesInfo[]
  cellValue?: unknown // Value extracted by TanStack Table's accessorFn (for nested data)
  handlers?: Record<string, any>
}

export interface Column {
  label: string
  displayLabel?: string // Alternative label for table header display (if different from dropdown label)
  name: string
  sortableName?: string
  // Path to nested property for data access (e.g., ["content_view_list.standards", "EACT"])
  // When present, TanStack Table will use accessorFn to access nested data
  accessorPath?: string[]
  // Name of description field or function-getter
  description?: string | ((record: TableRecordType) => React.ReactNode)
  sortable?: boolean
  // Show/hide column based on filters state.
  filter?: (filters: FiltersState) => boolean
  type?:
    | "number"
    | "percent"
    | "duration"
    | "chip"
    | "link"
    | "trend"
    | "horizontalProgress"
    | "circleProgress"
    | "achievementLevel"
    | "correct"
    | "contentType"
    | "usageContentType"
    | "dateTime"
    | "utcdate"
    | "localDate"
    | "activity"
    | "correctPercent"
    | "correctAnswers"
    | "reportingCategory"
    | "course"
    | "multipleItems"
  dateFormat?: string
  typeProp?: string | ((record: TableRecordType) => React.ReactNode)
  variant?: string | ((record: TableRecordType) => string)
  linkUrl?: string | ((record: TableRecordType) => React.ReactNode)
  linkTooltip?: string | ((record: TableRecordType) => React.ReactNode)
  formatter?: (
    record: TableRecordType,
    prop: string,
    context?: ColumnFormatterContextType
  ) => React.ReactNode
  // if empty or this property do not exist - item available for all content types
  // set ["default"] if this column exist in initial table
  columnContentTypes?: string[]
  columns?: Column[]
  size?: number
  canResize?: boolean
  tooltip?: React.ReactNode
  align?: "left" | "center" | "right"
  applySearchParams?: boolean
  diagonalHeader?: boolean
  mask?: boolean
}

export enum SortTypes {
  asc = "asc",
  desc = "desc"
}

export type Sorting = {
  sortBy: string
  order: SortTypes
}

export type SortHandler = (sortBy: string, order: SortTypes) => void

export type TableRecordType = {
  id: string
  sortableName?: string
  children?: TableRecordType[]
  [key: string]: any
}

export type SortProps = {
  sortBy?: string
  order?: SortTypes
  onSort?: (sortBy: string, order: SortTypes) => void
}

export type ScrollProps = {
  hasMoreItems?: boolean
  onFetch?: () => void
}
